import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import orderShippedSVG from 'icons/ordershipped.svg';
import { themePropTypes } from 'proptypes/theme.proptypes';
import { ReactSVG } from 'react-svg';
import { withTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

import { Container, IconWrapper, Text } from './LoadingScreen.styles';

const LoadingScreen = ({ theme }) => {
  const { bgImage, imageMessages } = theme.configs.loadingScreen;

  const [rotateMessageIdx, setRotateMessageIdx] = useState(0);

  useEffect(() => {
    if (imageMessages.length > 1) {
      const timer = setInterval(() => {
        setRotateMessageIdx((idx) => (idx + 1) % imageMessages.length);
      }, 3000);

      return () => clearInterval(timer);
    }

    return undefined;
  }, [imageMessages]);

  const { t } = useTranslation();

  const loadingMessage =
    imageMessages[rotateMessageIdx] || t('LOOKING_FOR_PARCEL');

  return (
    <Container>
      <IconWrapper>
        {bgImage ? (
          <ReactSVG
            src={bgImage}
            fallback={() => <img src={bgImage} alt="" />}
            aria-hidden
          />
        ) : (
          <ReactSVG src={orderShippedSVG} aria-hidden />
        )}
      </IconWrapper>
      <Text>{loadingMessage}</Text>
    </Container>
  );
};

LoadingScreen.propTypes = {
  theme: themePropTypes.isRequired,
};

export default withTheme(LoadingScreen);
